export default __webpack_public_path__ + "static/media/RatShadeImage.70c01548.webp";